import type { ListingBannersButton } from '@/shared/api/experience';
import { withMfsDomain } from '@/shared/lib/withMfsDomain';

export const useBannerNavigation = () => {
  const router = useRouter();
  const route = useRoute();

  const handleBannerClick = (button: ListingBannersButton | undefined) => {
    if (!button) {
      return;
    }

    if (button.link) {
      if (button.link.startsWith('/redirect')) {
        window.open(withMfsDomain(button.link), '_blank');
      } else {
        router.push(withMfsDomain(button.link));
      }

      return;
    }

    if (Object.keys(button?.link_params || {}).length) {
      const currentQuery = { ...route.query };
      const params = { ...currentQuery, ...(button.link_params as Record<string, string>) };
      router
        .push({
          query: params,
        })
        .catch(() => {});
    }
  };

  return {
    handleBannerClick,
  };
};
